@if (loading$ | async) {
  <app-loader></app-loader>
}
<router-outlet></router-outlet>
<div style="position: absolute; bottom: 5px; left: 0; z-index: 10;">
  <app-footer></app-footer>
</div>
